import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import {
  PagePaginationResponseDtoSchema,
  responseContract,
  type PagePaginationRequestDto,
} from '../../lib';

const GetSubscriptionsResponseDtoSchema = PagePaginationResponseDtoSchema(
  z.object({
    compSubscribed: z.boolean(),
    facilityId: z.number(),
    facilityName: z.string(),
    internalSubscribed: z.boolean(),
  })
);

export type GetSubscriptionsRequestDto = PagePaginationRequestDto<{}>;
export type GetSubscriptionsResponseDto = z.infer<
  typeof GetSubscriptionsResponseDtoSchema
>;

export const getSubscriptions = (
  params: PagePaginationRequestDto,
  config?: AxiosRequestConfig
) =>
  api
    .get('market-intel-subscription', { params, ...config })
    .then(responseContract(GetSubscriptionsResponseDtoSchema));
